import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useMemo } from 'react';
import { AutoSizer, CellMeasurer, CellMeasurerCache, List } from 'react-virtualized';
import { SelectStyles } from "./Select.styles.js";
export var SelectMenuOptionsVirtualized = function SelectMenuOptionsVirtualized(_ref) {
  var cursor = _ref.cursor,
    groupLabels = _ref.groupLabels,
    showGroupDivider = _ref.showGroupDivider,
    groups = _ref.groups,
    value = _ref.value,
    onOptionSelection = _ref.onOptionSelection,
    virtualizedContainerHeight = _ref.virtualizedContainerHeight,
    virtualizedContainerWidth = _ref.virtualizedContainerWidth,
    groupDivider = _ref.groupDivider,
    options = _ref.options;
  var _useMemo = useMemo(function () {
      var flattenedGroups =
      // Transform groups to a plain array
      groups.reduce(function (resultList, group) {
        var groupLabel = group.groupLabel,
          groupIndex = group.groupIndex;
        var mappedList = group.items.map(function (item, itemIndex) {
          return _objectSpread(_objectSpread({}, item), {}, {
            groupLabel: groupLabel,
            groupIndex: groupIndex,
            isFirstOfTheGroup: itemIndex === 0
          });
        });
        resultList.push.apply(resultList, _toConsumableArray(mappedList));
        return resultList;
      }, []);
      return {
        groupedOptions: flattenedGroups,
        groupFirstIndexes: flattenedGroups.map(function (option) {
          return option.isFirstOfTheGroup ? option.index : [];
        }).flat()
      };
    }, [groups]),
    groupedOptions = _useMemo.groupedOptions,
    groupFirstIndexes = _useMemo.groupFirstIndexes;
  var cache = useMemo(function () {
    return new CellMeasurerCache({
      fixedWidth: true,
      defaultHeight: virtualizedContainerHeight,
      minWidth: 75,
      keyMapper: function keyMapper(each) {
        return groupFirstIndexes.includes(each) ? each : 1;
      }
    });
  }, [options, virtualizedContainerHeight]);
  var rowRenderer = function rowRenderer(row) {
    var index = row.index,
      key = row.key;
    if ((groupLabels || showGroupDivider) && groupedOptions.length > 0) {
      var groupedOption = groupedOptions[index];
      if (!groupedOption) return null;
      return /*#__PURE__*/React.createElement(RowWithGroup, {
        key: key,
        cache: cache,
        currentOption: groupedOption,
        row: row,
        cursor: cursor,
        isSelected: value === groupedOption.value,
        onOptionSelection: onOptionSelection,
        showGroupDivider: showGroupDivider,
        groupDivider: groupDivider
      });
    }
    var option = options[index];
    if (!option) return null;
    return /*#__PURE__*/React.createElement(RowWithoutGroup, {
      key: key,
      cache: cache,
      cursor: cursor,
      currentOption: option,
      row: row,
      isSelected: value === option.value,
      onOptionSelection: onOptionSelection
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    style: {
      height: "".concat(virtualizedContainerHeight, "px"),
      width: virtualizedContainerWidth ? "".concat(virtualizedContainerWidth, "px") : 'auto'
    }
  }, /*#__PURE__*/React.createElement(AutoSizer, null, function (_ref2) {
    var width = _ref2.width;
    return /*#__PURE__*/React.createElement(List, {
      width: width,
      scrollToIndex: cursor,
      scrollToAlignment: "center",
      height: virtualizedContainerHeight,
      rowCount: options.length,
      rowHeight: cache.rowHeight,
      overscanRowCount: 2,
      deferredMeasurementCache: cache,
      rowRenderer: rowRenderer
    });
  }));
};
var RowWithoutGroup = function RowWithoutGroup(_ref3) {
  var currentOption = _ref3.currentOption,
    cursor = _ref3.cursor,
    isSelected = _ref3.isSelected,
    row = _ref3.row,
    cache = _ref3.cache,
    onOptionSelection = _ref3.onOptionSelection;
  return /*#__PURE__*/React.createElement(RowContainer, {
    row: row,
    cache: cache
  }, /*#__PURE__*/React.createElement(SelectStyles.MenuItemStyled, {
    className: "virtualized-row ".concat(cursor === row.index ? 'active' : '', " "),
    selected: isSelected,
    onClick: function onClick() {
      return onOptionSelection(currentOption.value);
    },
    role: "option"
  }, currentOption.label));
};
var RowWithGroup = function RowWithGroup(_ref4) {
  var currentOption = _ref4.currentOption,
    cursor = _ref4.cursor,
    isSelected = _ref4.isSelected,
    row = _ref4.row,
    cache = _ref4.cache,
    onOptionSelection = _ref4.onOptionSelection,
    showGroupDivider = _ref4.showGroupDivider,
    groupDivider = _ref4.groupDivider;
  var index = row.index;
  var isFirstOfTheGroup = currentOption.isFirstOfTheGroup,
    groupLabel = currentOption.groupLabel,
    value = currentOption.value,
    label = currentOption.label;
  return /*#__PURE__*/React.createElement(RowContainer, {
    row: row,
    cache: cache
  }, isFirstOfTheGroup && index > 0 && showGroupDivider ? groupDivider || /*#__PURE__*/React.createElement(SelectStyles.GroupDivider, {
    marginTop: true
  }) : null, isFirstOfTheGroup && groupLabel && /*#__PURE__*/React.createElement(SelectStyles.ListSubheaderStyled, null, groupLabel), /*#__PURE__*/React.createElement(SelectStyles.MenuItemStyled, {
    className: "virtualized-row ".concat(cursor === index ? 'active' : '', " "),
    selected: isSelected,
    onClick: function onClick() {
      return onOptionSelection(value);
    },
    role: "option"
  }, label));
};
var RowContainer = function RowContainer(_ref5) {
  var cache = _ref5.cache,
    row = _ref5.row,
    children = _ref5.children;
  var key = row.key,
    parent = row.parent,
    style = row.style,
    index = row.index;
  return /*#__PURE__*/React.createElement(CellMeasurer, {
    key: key,
    cache: cache,
    parent: parent,
    columnIndex: 0,
    rowIndex: index
  }, function (_ref6) {
    var registerChild = _ref6.registerChild;
    return /*#__PURE__*/React.createElement("span", {
      ref: registerChild,
      style: style,
      key: key
    }, children);
  });
};